export enum AiVoiceTone {
  Professional = 'professional',
  Casual = 'casual',
  Concise = 'concise',
}

export interface IAiReceptionistSettings {
  ai_receptionist_settings_id?: string
  clinic_id: string
  enabled: boolean
  name: string
  voice_style: string
  voice_tone: AiVoiceTone
  controls: string[] // new_booking, reschedule, cancel, faq
  languages: string[]
  verification_enabled: boolean
  verification_required_for: string[]
  verification_fields: string[]
  queue_after: number
  answer_faqs: boolean
  schedule_approved_types: boolean
  reschedule_cancel: boolean
  detect_urgent: boolean
  create_callback_tasks: boolean
  clinical_guidance: boolean
  default_callback: string
  emergency_callback: string
  insurance_callback: string
  default_response: string
  emergency_response: string
  insurance_response: string
  escalation_scenarios: string[]
  prompt: string
  services: string[]
  information_database: string
  knowledge_approved_services: string
  knowledge_insurance_membership: string
  knowledge_location_access: string
  knowledge_restricted_actions: string
  knowledge_restricted_enabled: boolean
  knowledge_base_enabled: boolean
  confirmation_template_id: string
  reschedule_template_id: string
  channels: string[]
  sms_booking_unconfirmed: string
  sms_booking_confirmed: string
  sms_reschedule: string
  sms_cancel: string
  sms_default_response_value: number
  sms_default_response_unit: 'minutes' | 'hours'
  sms_answer_during_lunch: boolean
  sms_answer_when_closed: boolean
  created_by: string
  updated_by: string
  date_time_created_at?: string
  date_time_updated_at?: string
}

export type AiReceptionistFieldErrorKey =
  | 'channels'
  | 'controls'
  | 'languages'
  | 'verification_fields'
  | 'verification_required_for'
  | 'services'
  | 'voice_style'
  | 'voice_tone'
  | 'sms_booking_unconfirmed'
  | 'sms_booking_confirmed'
  | 'sms_reschedule'
  | 'sms_cancel'
  | 'sms_default_response_value'

export type AiReceptionistFieldErrors = Partial<
  Record<AiReceptionistFieldErrorKey, string>
>

export const DEFAULT_AI_CHANNELS = ['call', 'sms'] as const

export const DEFAULT_SMS_BOOKING_UNCONFIRMED = `Hi <span class="ds-rich-text-editor__variable" data-variable-id="patient_name">{{patient_name}}</span>, we received your appointment request at <span class="ds-rich-text-editor__variable" data-variable-id="clinic_name">{{clinic_name}}</span>&nbsp;for <span class="ds-rich-text-editor__variable" data-variable-id="date">{{date}}</span>&nbsp;at <span class="ds-rich-text-editor__variable" data-variable-id="time">{{time}}</span>&nbsp; (<span class="ds-rich-text-editor__variable" data-variable-id="service">{{service}}</span>). A staff member will contact you once it is confirmed.`

export const DEFAULT_SMS_BOOKING_CONFIRMED = `<span style="font-family: inherit;">Hi </span><span class="ds-rich-text-editor__variable" data-variable-id="patient_name" style="font-family: inherit;">{{patient_name}}</span><span style="font-family: inherit;">, your appointment at </span><span class="ds-rich-text-editor__variable" data-variable-id="clinic_name" style="font-family: inherit;">{{clinic_name}}</span><span style="font-family: inherit;"> is confirmed for </span><span class="ds-rich-text-editor__variable" data-variable-id="date">{{date}}</span>&nbsp;<span style="font-family: inherit;">at </span><span class="ds-rich-text-editor__variable" data-variable-id="time">{{time}}</span>&nbsp;<span style="font-family: inherit;">with  (</span><span class="ds-rich-text-editor__variable" data-variable-id="service">{{service}}</span><span style="font-family: inherit;">). We look forward to seeing you.</span>`

export const DEFAULT_SMS_RESCHEDULE = `Hi <span class="ds-rich-text-editor__variable" data-variable-id="patient_name">{{patient_name}}</span>, your appointment at <span class="ds-rich-text-editor__variable" data-variable-id="clinic_name">{{clinic_name}}</span>&nbsp;was rescheduled to <span class="ds-rich-text-editor__variable" data-variable-id="date">{{date}}</span>&nbsp;at <span class="ds-rich-text-editor__variable" data-variable-id="time">{{time}}</span>&nbsp;(<span class="ds-rich-text-editor__variable" data-variable-id="service">{{service}}</span>). If you have questions, please call the clinic.`

export const DEFAULT_SMS_CANCEL = `Hi <span class="ds-rich-text-editor__variable" data-variable-id="patient_name">{{patient_name}}</span>, your appointment at <span class="ds-rich-text-editor__variable" data-variable-id="clinic_name">{{clinic_name}}</span> on <span class="ds-rich-text-editor__variable" data-variable-id="date">{{date}}</span> at <span class="ds-rich-text-editor__variable" data-variable-id="time">{{time}}</span>&nbsp;has been cancelled. Please call the clinic if you need to rebook.`
